package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.InventoryItem
import fr.manyverse.app.domain.repository.InventoryRepository

class GetInventoryItemsUseCase(
    private val inventoryRepository: InventoryRepository
) {
    suspend operator fun invoke(characterId: String): Result<List<InventoryItem>> {
        return inventoryRepository.getItemsForCharacter(characterId)
    }
}
